<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        class="card-speech mb-0"
        no-body
      >
        <div class="card-header">
          <div class="header-left">
            <h3>
              Chuyển văn bản thành âm thanh
            </h3>
            <h4 class="text-wrap">
              {{ articleData.title }}
            </h4>
          </div>
        </div>

        <b-card-body class="p-1">
          <h4>Nội dung</h4>
          <b-card
            class="card-tts-content mb-0"
            no-body
          >
            <b-form-textarea
              v-model="textData"
              placeholder="nhập nội dung..."
              rows="18"
              spellcheck="false"
              @keydown.enter.prevent=""
              @keydown="onInputText"
              @paste="onPasteText"
            />
            <p class="small my-1">
              <i>
                <span class="text-danger">Lưu ý:</span>
                Nội dung chuyển đổi không quá
                {{ maxChar }} kí tự. Tổng <span>{{ textLength }}</span>
              </i>
            </p>
          </b-card>
          <h4>Chọn giọng đọc</h4>
          <b-row>
            <b-col
              v-for="(item, index) in voices"
              :key="index"
              class="col-12 mb-1"
            >
              <b-form-radio-group
                v-model="voice"
                :options="item.voices"
                value-field="id"
                text-field="name"
                disabled-field="notEnabled"
                class="demo-inline-spacing"
              />
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-footer>
          <div
            id="audio-wrapper"
            ref="refAudioWrapper"
            class="speech-control"
          >
            <div class="speech-actions">
              <b-button
                v-if="loading !== 4"
                variant="primary"
                :disabled="loading"
                @click="startTranscribe()"
              >

                <b-spinner
                  v-if="loading === 2 || loading === 3"
                  small
                />
                <feather-icon
                  v-else
                  icon="RotateCwIcon"
                />
                {{ loading === 2 || loading === 3 ? 'Đang chuyển sang văn bản' : 'Chuyển sang văn bản' }}
              </b-button>
              <!-- <b-button
                v-else
                variant="primary"
                @click="addTextToEditor()"
              >
                <feather-icon icon="PlusIcon" /> Thêm vào tin
              </b-button> -->

            </div>
          </div>
        </b-card-footer>
      </b-card>

    </b-overlay>
  </div>
</template>
<script>
import {
  BCard, BCardTitle, BCardFooter, BCardBody, BRow, BCol, BButton, BOverlay, BSpinner, BFormTextarea, BFormCheckbox, BFormRadio,
  BFormRadioGroup,
} from 'bootstrap-vue'
import {
  ref, toRefs, computed, reactive, watch, nextTick,
} from '@vue/composition-api'
import { io } from 'socket.io-client';
import store from '@/store'
import { showToast } from '@/@core/utils/utils'
import {
  apiUpload, apiDownload,
} from '@/libs/initTinymce'
import { getToken } from '@/auth/utils';
// import SocketSpeech from '@/libs/socket.speech';

export default {
  components: {
    BCard,
    BCardTitle,
    BCardFooter,
    BCardBody,
    BRow,
    BCol,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BButton,
    BOverlay,
    BSpinner,
  },
  props: {
    articleData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      socketSpeech: null,
      socketId: '',
      speechLog: '',
      content_id: '',
      // textData: '',
      locations: [],
      location: '',
      voice: '',
      // textLength: 0,
      is_convert: false,
      voices: [
        {
          id: 'mienbac',
          name: 'Miền Bắc',
          voices: [
            { id: 'north_male_hieu', name: 'Hiếu' },
            { id: 'north_female_lien', name: 'Liên' },
            { id: 'north_female_nga', name: 'Nga' },
            { id: 'north_female_vananh', name: 'Vân Anh' },
            { id: 'ptv_nguyet', name: 'Nguyệt' },
            { id: 'ptv_nam', name: 'Nam' },
            { id: 'ptv_thao', name: 'Thảo' },
            { id: 'ptv_son', name: 'Sơn' },
          ],
        },
        // {
        //   id: 'mientrung',
        //   name: 'Miền Trung',
        //   voices: [],
        // },
        // {
        //   id: 'miennam',
        //   name: 'Miền Nam',
        //   voices: [],
        // },
      ],
    }
  },
  computed: {

  },
  setup(props, context) {
    const link = ref('')
    const loading = ref(false)
    const maxChar = 2000
    const textData = ref('')

    const limitText = (textdata) => {
      const doc = new DOMParser().parseFromString(textdata, 'text/html');
      let content = doc.body.textContent || '';
      content = content.replace((/ {2}|\r\n|\n|\r/gm), '');
      return content.substring(0, maxChar);
    }

    if (props.articleData) {
      textData.value = limitText(props.articleData.content);
    }

    const textLength = computed({
      get() {
        return this.textData.length;
      },
      set(val) {

      },
    })

    const onInputText = () => {
      console.log('1. textData.value', textData.value);
      textData.value = limitText(textData.value)
      console.log('2. textData.value', textData.value);
    }
    const onPasteText = () => {
      setTimeout(() => {
        textData.value = limitText(textData.value)
      }, 200);
    }

    const ttsStatus = ref({
      get() {
        return this.articleData.tts;
      },
      set(val) {
        console.log('set ttsStatus', val);
      },
    });

    const state = reactive({
      api_upload: apiUpload,
      api_download: apiDownload,
    })

    return {
      ...toRefs(state),
      link,
      loading,
      ttsStatus,
      textData,
      textLength,
      maxChar,
      limitText,
      onInputText,
      onPasteText,
    }
  },
  watch: {
    '$store.state.speech.isDisconnectSocket': function () {
      this.disconnectSocket();
    },
  },
  mounted() {
    this.initSocket()
  },
  unmounted() {
    console.log('unmounted');
    // this.disconnectSocket();

    this.clearTimerCheckTranscribe();
  },
  methods: {

    initSocket() {
      // const socketSpeech = SocketSpeech.init(this.articleData, this.generateTextPart);
      // console.log('socketSpeech:', socketSpeech);

      const that = this
      const socketUrl = process.env.VUE_APP_SPEECH_SOCKET || 'http://localhost:3006';
      const socketPath = process.env.VUE_APP_SPEECH_SOCKET_PATH || '/socket.io/';
      const socket = io(socketUrl, {
        path: socketPath,
        transports: ['websocket'],
      });
      console.log('socketUrl', socketUrl);
      console.log('socketPath', socketPath);
      this.socketSpeech = socket;

      socket.on('connect', () => {
        console.log('socket speech on connect');
        this.socketId = socket.id;
      });
      socket.on('file-ttsd', (data) => {
        // console.log('socket on file-ttsd data', data);
        if (data && data.id === that.articleData.id) {
          showToast(`Rải băng ${that.articleData.filename_original} thành công`, { variant: 'success' });
          // console.log('data.file_id, this.articleData.id', data.id, that.articleData.id);
          // const jsonPretty = JSON.stringify(data, null, 2);
          // const payload = {
          //   fileName: data.fileName,
          //   articleData: data.articleData,
          //   provider: data.provider,
          // }
          if (data.tts) {
            that.updateTranscribeStatus(data.tts);
            this.getFileTranscribe();
          }
          // console.log(`<p>${jsonPretty}</p>`);
        }
      });
      socket.on('test-send-message', () => {
        showToast('test send message');
      });
      socket.on('disconnect', () => {
        console.log('socket speech on disconnect');
      });
    },

    disconnectSocket() {
      if (this.socketSpeech) {
        this.socketSpeech.disconnect();
      }
    },

    updateTranscribeStatus(status) {
      this.articleData.tts = status;
      this.articleData.status = status;
      this.ttsStatus = status;
      // console.log('update-tts-status ', { id: this.articleData.id, tts: status });
      this.$emit('update-tts-status', { id: this.articleData.id, tts: status });
    },
    getFileTranscribe() {
      this.loading = true
      store.dispatch('speech/getFileTranscribe', {
        file_id: this.articleData.id,
      })
        .then(response => {
          this.loading = false
          if (response.data.code === 200) {
            // console.log('response.data.data', response.data.data);
            const { text, text_parts, status } = response.data.data;
            // this.ttsText = text;
            this.ttsTextParts = text_parts;
            this.generateTextPart(text_parts);
            this.updateTranscribeStatus(status);

            // console.log('getFileTranscribe status: ', status);
          } else {
            this.updateTranscribeStatus(1);
            // showToast(response.data.message);
          }
        })
    },
    getTranscribeText(articleData) {
      this.getFileTranscribe()
    },
    startTranscribe() {
      return console.log('startTranscribe ', this.textData);
      // console.log('startTranscribe tts/ttsStatus:', this.articleData.tts, this.ttsStatus);
      if (this.articleData.tts === 2 || this.articleData.tts === 3) {
        showToast('File đang được xử lý. Vui lòng đợi trong giây lát', { variant: 'success' });
      } else if (this.articleData.tts === 1 || this.articleData.tts === 5 || this.articleData.tts === 6) {
        this.loading = true
        const payload = {
          articleData: {
            id: this.articleData.id,
            fileName: this.articleData.file,
            file: this.articleData.file_local,
            access_token: getToken(),
          },
          file: this.articleData.file_local,
          provider: 'aimes',
          stage: 'upload_and_convert',
        }
        this.updateTranscribeStatus(2);
        // console.log('this.articleData.tts', this.articleData.tts);
        this.loading = false
        // this.$emit('update-tts-status', { id: this.articleData.file_id, tts: this.articleData.tts });

        store.dispatch('speech/startTranscribe', payload)
          .then(response => {
            // console.log('startTranscribe res', response)
            this.loading = false
            const { code, message, data } = response.data;
            if (code === 200) {
              this.updateTranscribeStatus(data.status);
              // this.articleData.tts = data.status;
              // this.$emit('update-tts-status', { tts: this.articleData.tts });
              // console.log('this.articleData.tts', this.articleData.tts);

              // watching every 10s to get text
              // this.startTimerCheckTranscribe();
            } else {
              showToast(message);
            }
          })
      }
    },

    hideModal() {
      // console.log('click hide modal');
      this.$emit('hide-tts-modal');
    },
    formatText(text) {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      let content = doc.body.textContent || '';
      content = content.replace((/ {2}|\r\n|\n|\r/gm), '');
      content = content.substring(0, this.maxChar);
      return content;
    },
    convertTextToAudio(data) {
      const self = this;
      if (ajax_loading || self.content_id == '' || self.content_id == 0 || self.content_id == undefined) return;
      window.textToSpeechXhr = $.ajax({
        url: route('admin/news/convert-text-to-speech'),
        type: 'post',
        data,
        dataType: 'json',
        async: true,
        beforeSend() {
          ajax_loading = true;
          self.is_convert = true;
        },
        success(d) {
          ajax_loading = false;
          self.is_convert = false;
          if (d.errCode) {
            if (d.audio_settings.length) {
              $.each(d.audio_settings, function () {
                this.file_fullpath = `${this.file_fullpath}?t=${(new Date()).getTime()}`;
              });
            }
            $('#modal_render_audio').modal('hide');
            self.audio_settings = d.audio_settings;
          }
          showMessage(d.errMsg);
          self.updateAudioSrc();
        },
        error() {
          ajax_loading = false;
          self.is_convert = false;
        },
      });
    },
    removeAudioFile(item, index) {
      this.convertTextToAudio({
        id: this.content_id,
        audio_file: item.file,
        index,
        type: 'remove',
      });
    },
    convert() {
      if (this.textData.length > this.maxChar) {
        return showToast(`Tối đa ${this.maxChar} kí tự`);
      }
      if (this.voice.length === 0) {
        return showToast('Chưa chọn giọng đọc');
      }
      const opts = {
        location: this.location,
        voice: [this.voice],
        textData: this.textData,
        id: this.content_id,
        type: 'convert',
      };
      // return console.log(opts);
      return this.convertTextToAudio(opts);
    },
    stopConvert() {
      window.textToSpeechXhr.abort();
    },
    updateAudioSrc() {
      const self = this;
      if (self.audio_settings.length) {
        $.each(self.audio_settings, () => {
          const audio = $(`#audio_player_${this.id}`);
          console.log(this.id, audio)
          audio.attr('src', this.file_fullpath);
          audio[0].pause();
          audio[0].load();
        });
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-slider.scss';

.card-tts-voice {
  border: 1px solid #d8d6de;
}
</style>
